import React from "react";
import styled from "styled-components/macro";

const Spinner = (props) => {
    let s = {
        cx: 25,
        cy: 25,
        r: 20,
        color: '#5652bf',
        height: 50,
        width: 50
    }
    if(props.inline){
        s.r = 20;
        s.color = '#ffffff';
        s.height = 16;
        s.width = 16;
    }
    return (
        <StyledSpinner viewBox="0 0 50 50" color={s.color} height={s.height} width={s.width}>
            <circle className="path" cx={s.cx} cy={s.cy} r={s.r} fill="none" strokeWidth="2"/>
        </StyledSpinner>
    )
};

const StyledSpinner = styled.svg`
  animation: rotate 1s linear infinite;
  width: ${p => p.width}px;
  height: ${p => p.height}px;

  & .path {
    stroke: ${p => (p.color)};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

export default Spinner;
